var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2137 27.2734C18.2137 29.4579 16.5532 31.2263 14.5019 31.2263C12.4506 31.2263 10.79 29.4579 10.79 27.2734",
    stroke: "#FF952C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0584 24.72L25.096 21.623V16.4219C25.096 10.7338 21.6328 5.93457 17.0063 4.63429C17.0063 4.57283 17.024 4.51609 17.024 4.45462C17.024 2.97467 15.8963 1.77368 14.5066 1.77368C13.1168 1.77368 11.9846 2.97467 11.9846 4.45462C11.9846 4.51609 11.998 4.57283 12.0024 4.63429C7.37593 5.92984 3.91274 10.7338 3.91274 16.4219V21.6325L1.95026 24.7153C1.31978 25.7035 1.98578 27.0416 3.1091 27.0416H25.8996C27.0229 27.0416 27.6889 25.7083 27.0584 24.7153V24.72Z",
    stroke: "#FF952C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.a1ce100a9ddb5e69d80c0c17b41db5b3.svg";
export { ForwardRef as ReactComponent };